/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_BuilderInputs */

const en_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder`)
};

const es_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Astillero / Constructor`)
};

const fr_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructeur`)
};

const de_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werft / Erbauer`)
};

const ja_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`造船所/ビルダー`)
};

const zh_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建造商`)
};

const ar_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الباني / الشركة المصنعة`)
};

const id_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembuat`)
};

const it_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantiere / Costruttore`)
};

const ru_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верфь`)
};

const pt_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construtor / Estaleiro`)
};

const ko_field_builder = /** @type {(inputs: Field_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`건조사(Builder)`)
};

/**
* | output |
* | --- |
* | "Builder" |
*
* @param {Field_BuilderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_builder = /** @type {((inputs?: Field_BuilderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_BuilderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_builder(inputs)
	if (locale === "es") return es_field_builder(inputs)
	if (locale === "fr") return fr_field_builder(inputs)
	if (locale === "de") return de_field_builder(inputs)
	if (locale === "ja") return ja_field_builder(inputs)
	if (locale === "zh") return zh_field_builder(inputs)
	if (locale === "ar") return ar_field_builder(inputs)
	if (locale === "id") return id_field_builder(inputs)
	if (locale === "it") return it_field_builder(inputs)
	if (locale === "ru") return ru_field_builder(inputs)
	if (locale === "pt") return pt_field_builder(inputs)
	return ko_field_builder(inputs)
});